// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDatePicker-Header_cls1__jjYR+","cls2":"VeloDatePicker-Header_cls2__Ar6Dt VeloDatePicker-Header_cls1__jjYR+"};